/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompletedRound } from './CompletedRound';
import {
    CompletedRoundFromJSON,
    CompletedRoundFromJSONTyped,
    CompletedRoundToJSON,
    CompletedRoundToJSONTyped,
} from './CompletedRound';

/**
 * 
 * @export
 * @interface CompletedTraining
 */
export interface CompletedTraining {
    /**
     * 
     * @type {string}
     * @memberof CompletedTraining
     */
    entryId?: string;
    /**
     * 
     * @type {Array<CompletedRound>}
     * @memberof CompletedTraining
     */
    rounds: Array<CompletedRound>;
}

/**
 * Check if a given object implements the CompletedTraining interface.
 */
export function instanceOfCompletedTraining(value: object): value is CompletedTraining {
    if (!('rounds' in value) || value['rounds'] === undefined) return false;
    return true;
}

export function CompletedTrainingFromJSON(json: any): CompletedTraining {
    return CompletedTrainingFromJSONTyped(json, false);
}

export function CompletedTrainingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletedTraining {
    if (json == null) {
        return json;
    }
    return {
        
        'entryId': json['entryId'] == null ? undefined : json['entryId'],
        'rounds': ((json['rounds'] as Array<any>).map(CompletedRoundFromJSON)),
    };
}

export function CompletedTrainingToJSON(json: any): CompletedTraining {
    return CompletedTrainingToJSONTyped(json, false);
}

export function CompletedTrainingToJSONTyped(value?: CompletedTraining | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entryId': value['entryId'],
        'rounds': ((value['rounds'] as Array<any>).map(CompletedRoundToJSON)),
    };
}

